import routes from "../routes/Services.routes";
import axios from "axios";

export default async function getFromCartApi(
  setCartItems,
  setY,
  setLoading,
  setError
) {
  return await axios
    .get(routes.GetCartItems, {
      headers: {
        token: localStorage.getItem("token"),
      },
    })
    .then((res) => {
      let data = res.data;
      let x = data.map((item, index) => {
//         var json = item
// json.id = index
// json.isChecked = true
// json.registrationType = 'registrationType'
// return json
        // Spread `item` first so `item_id` / `id` are not overwritten by API fields
        // with the same keys (some payloads include `item_id` meaning something else).
        return {
          ...item,
          id: index,
          isChecked: true,
          item_id: item._id,
          item_type: item.course_type,
          registrationType: "full",
        };
      })
      setY(x);
      setCartItems(res.data);
      setLoading(false);
      return res.data;
    })
    .catch((err) => {
      // console.log(err);
      // console.log(err.message);
      setLoading(false);
      setError(err.message);
    });
}
